"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spotify1Schema = void 0;
exports.Spotify1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Spotify1",
    "description": "Add a spotify play button",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:spotify-audio:1"
            ]
        },
        "attributes": {
            "type": "object",
            "oneOf": [
                {
                    "required": [
                        "href"
                    ]
                },
                {
                    "required": [
                        "uri"
                    ]
                }
            ],
            "properties": {
                "href": {
                    "type": "string",
                    "description": "Spotify URL (https://play.spotify.com/track/0ZSdQvYFSY7BNjJEB6t0P3)",
                    "pattern": "^((http|https):/{2})(([0-9a-z_-]+[.])+)com.*$"
                },
                "uri": {
                    "type": "string",
                    "description": "A spotify URI, e.g. spotify:artist:5lsC3H1vh9YSRQckyGv0Up",
                    "pattern": "^(spotify:).*$"
                }
            }
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zcG90aWZ5LWF1ZGlvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsY0FBYyxHQUFHO0lBQzVCLEtBQUssRUFBRSxrRkFBa0Y7SUFDekYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsVUFBVTtJQUNuQixhQUFhLEVBQUUsMkJBQTJCO0lBQzFDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwwQ0FBMEM7YUFDM0M7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE9BQU8sRUFBRTtnQkFDUDtvQkFDRSxVQUFVLEVBQUU7d0JBQ1YsTUFBTTtxQkFDUDtpQkFDRjtnQkFDRDtvQkFDRSxVQUFVLEVBQUU7d0JBQ1YsS0FBSztxQkFDTjtpQkFDRjthQUNGO1lBQ0QsWUFBWSxFQUFFO2dCQUNaLE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLHFFQUFxRTtvQkFDcEYsU0FBUyxFQUFFLCtDQUErQztpQkFDM0Q7Z0JBQ0QsS0FBSyxFQUFFO29CQUNMLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsMkRBQTJEO29CQUMxRSxTQUFTLEVBQUUsZ0JBQWdCO2lCQUM1QjthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=